import CitySEOHead from "@/components/feature/CitySEOHead";
import KennerHeroSection from "./components/HeroSection";
import KennerStickyNav from "./components/StickyNav";
import KennerProcessingTimeSection from "./components/ProcessingTimeSection";
import KennerServicesSection from "./components/ServicesSection";
import KennerLocalAreaSection from "./components/LocalAreaSection";
import KennerTestimonialsSection from "./components/TestimonialsSection";
import KennerAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import KennerComparisonSection from "./components/ComparisonSection";
import KennerMistakesSection from "./components/MistakesSection";
import KennerHowItWorksSection from "./components/HowItWorksSection";
import KennerFAQSection, { faqs } from "./components/FAQSection";
import KennerHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import KennerFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import KennerTravelTimingSection from "./components/TravelTimingSection";
import KennerDestinationsSection from "./components/DestinationsSection";

export default function KennerPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Kenner"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/kenner"
        title="Emergency Passport Kenner, LA — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Kenner, LA — as fast as 24 hours. Serving MSY airport workers, Jefferson Parish families, and New Orleans cruise passengers. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Kenner, Louisiana"
        geoPosition="29.9941;-90.2417"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <KennerHeroSection />
      <KennerStickyNav />
      <KennerProcessingTimeSection />
      <KennerServicesSection />
      <KennerLocalAreaSection />
      <KennerTravelTimingSection />
      <KennerDestinationsSection />
      <KennerTestimonialsSection />
      <KennerAcceptanceFacilitiesSection />
      <KennerComparisonSection />
      <KennerMistakesSection />
      <KennerHowItWorksSection />
      <KennerFAQSection />
      <KennerHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/kenner" state="LA" />
      <KennerFinalCTA />
    </div>
  );
}